import { routingProfileSchema } from './routing-profile.schema';
import { z } from 'zod/v4';

export const defaultRoutingProfileSchema = routingProfileSchema.omit({
  isAccountDefault: true,
});

export type DefaultRoutingProfile = z.infer<typeof defaultRoutingProfileSchema>;
